import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_PortfolioFilterBody = _resolveComponent("PortfolioFilterBody");
  const _component_FilterItem = _resolveComponent("FilterItem");
  return _openBlock(), _createBlock(_component_FilterItem, {
    id: "portfolios",
    ref: "portfolioFilterItem",
    icon: "CertificateIcon",
    title: $options.getPortfolioTitle,
    selectedTitle: $options.getPortfolioSelectedTitle,
    selectedCount: $props.portfolios?.filterState?.selectedCount,
    onClearAll: $options.handleClearAll,
    onApply: $options.onApply,
    onHidden: $options.onHidden
  }, {
    body: _withCtx(() => [_createVNode(_component_PortfolioFilterBody, {
      title: "Portfolio",
      selected: $props.portfolios?.filterState?.selected,
      isModified: $props.portfolios.isModified,
      pendingChanges: $props.portfolios.pendingChanges,
      isSearching: $props.portfolios.isSearching,
      keyword: $props.portfolios.keyword,
      list: $props.portfolios.displayList,
      onClear: $options.handleClear,
      onDiscard: $options.onDiscard,
      onRestoreSearch: $options.onRestoreSearch,
      onSelect: $options.handleSelect,
      onSelectOnly: $options.handleSelectOnly,
      onSelectAll: _cache[0] || (_cache[0] = $event => $props.portfolios.selectAll()),
      onDeselect: $options.handleDeselect,
      onApply: $options.onApply,
      onSearch: $options.handlePortfolioSearch,
      onHidden: $options.onHidden,
      onCloseDropdown: _ctx.$refs?.portfolioFilterItem?.closeDropdown
    }, null, 8, ["selected", "isModified", "pendingChanges", "isSearching", "keyword", "list", "onClear", "onDiscard", "onRestoreSearch", "onSelect", "onSelectOnly", "onDeselect", "onApply", "onSearch", "onHidden", "onCloseDropdown"])]),
    _: 1
  }, 8, ["title", "selectedTitle", "selectedCount", "onClearAll", "onApply", "onHidden"]);
}